











































import {Component, Watch, Prop, Emit} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {FlowHierarchyTypeEnum, StatusEnum} from '@/services/models/Enums';
import {cloneDeep} from 'lodash';
import ConstantsHelperMixin from '@/components/helpers/constants-helper-mixin';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';

@Component
export default class LpPixelTreeview extends mixins(ConstantsHelperMixin, FlowMixin) {
  @Prop({ default: {} })
  flow: any;

  @Prop()
  selectedLanding: any;

  @Emit('update:selected-landing')
  onUpdateSelectedLanding(value: any) {
  }

  count: number = 0;
  flowRedistry: { [type: number]: string } = {};
  flowMap: TreeViewItem[] = [];

  get treeLeafs() {
    return [
      {
        index: 'landings',
        type: FlowHierarchyTypeEnum.landing,
        i18nValue: 'landings',
        i18nDefault: 'Landings'
      }
    ]
  }

  mounted() {
    this.onFlowChanged()
  }

  @Watch('flow')
  onFlowChanged() {
    this.flowRedistry = {};
    this.flowMap = this.createTree(this.flow.rules);
  }

  isTreeNodeLanding(node: TreeViewItem) {
    return node.type === FlowHierarchyTypeEnum.landing;
  }

  isTreeNodeLandingActive(node: TreeViewItem) {
    return this.isTreeNodeLanding(node) && this.selectedLanding?.id === node.id;
  }

  handleSelectLanding(node: TreeViewItem) {
    if (this.isTreeNodeLanding(node)) {
      this.onUpdateSelectedLanding(node);
    }
  }

  createTree(data: any[], type: FlowHierarchyTypeEnum = FlowHierarchyTypeEnum.rule, meta: any = {}): TreeViewItem[] {
    let res: TreeViewItem[] = [];

    data
      .filter(item => item.status !== StatusEnum.inactive)
      .forEach((item: any, index: number) => {
        let el: TreeViewItem = {
          id: this.count += 1,
          name: item.name,
          type: type,
          children: [],
          conditions: item.conditions
            ? this.generate_name(item, false)
            : null,
          meta: cloneDeep(meta)
        };

        el.meta[type] = index;

        if (item.paths && item.paths.length) {
          el.children = this.createTree(item.paths, FlowHierarchyTypeEnum.path, el.meta);
        } else {
          if (item.directLinking) {
            el.children.push({
              id: this.count += 1,
              name: this.t('Direct linking is enabled in this path'),
              type: FlowHierarchyTypeEnum.utility,
              children: [],
            });
          } else {
            this.treeLeafs.forEach((subItem) => {
              if (item[subItem.index] && item[subItem.index].length) {
                item[subItem.index].forEach((noname: any, landingIndex: number) => {
                  if (noname.id != '') {
                    let landing = {
                      ...noname,
                      id: this.count++,
                      type: subItem.type,
                      name: noname.nameFull,
                    }

                    landing.meta = cloneDeep(el.meta);
                    landing.meta[subItem.type] = landingIndex;
                    this.flowRedistry[landing.id] = noname.id;
                    el.children.push(landing);
                  }
                });
              }
            });
          }
        }

        res.push(el);
      });

    return res;
  }
}
